"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostPager = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/link/semantics/pager");
/** 글 상세 끝에서 이전·다음 글로 이동한다. */
let PostPager = class PostPager extends lit_1.LitElement {
    render() {
        const { previous, next } = this;
        return (0, lit_1.html) `
      <mm-pager
        aria-label="글 이동"
        .previous=${previous && {
            href: previous.href,
            heading: previous.title,
            description: '이전 글',
        }}
        .next=${next && { href: next.href, heading: next.title, description: '다음 글' }}
      ></mm-pager>
    `;
    }
};
PostPager.styles = (0, lit_1.css) `
    :host {
      display: block;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], PostPager.prototype, "previous", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], PostPager.prototype, "next", void 0);
PostPager = __decorate([
    (0, decorators_js_1.customElement)('mm-post-pager')
], PostPager);
exports.PostPager = PostPager;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9zdC1wYWdlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInBvc3QtcGFnZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQTJDO0FBQzNDLHFEQUEyRDtBQUUzRCxvREFBaUQ7QUFPakQsOEJBQThCO0FBRXZCLElBQU0sU0FBUyxHQUFmLE1BQU0sU0FBVSxTQUFRLGdCQUFVO0lBU3ZDLE1BQU07UUFDSixNQUFNLEVBQUUsUUFBUSxFQUFFLElBQUksRUFBRSxHQUFHLElBQUksQ0FBQTtRQUUvQixPQUFPLElBQUEsVUFBSSxFQUFBOzs7b0JBR0ssUUFBUSxJQUFJO1lBQ3RCLElBQUksRUFBRSxRQUFRLENBQUMsSUFBSTtZQUNuQixPQUFPLEVBQUUsUUFBUSxDQUFDLEtBQUs7WUFDdkIsV0FBVyxFQUFFLE1BQU07U0FDcEI7Z0JBQ08sSUFBSSxJQUFJLEVBQUUsSUFBSSxFQUFFLElBQUksQ0FBQyxJQUFJLEVBQUUsT0FBTyxFQUFFLElBQUksQ0FBQyxLQUFLLEVBQUUsV0FBVyxFQUFFLE1BQU0sRUFBRTs7S0FFaEYsQ0FBQTtJQUNILENBQUM7O0FBdEJNLGdCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7R0FJbEIsQ0FBQTtBQUMrQjtJQUEvQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxTQUFTLEVBQUUsS0FBSyxFQUFFLENBQUM7MkNBQXlCO0FBQ3hCO0lBQS9CLElBQUEsd0JBQVEsRUFBQyxFQUFFLFNBQVMsRUFBRSxLQUFLLEVBQUUsQ0FBQzt1Q0FBcUI7QUFQekMsU0FBUztJQURyQixJQUFBLDZCQUFhLEVBQUMsZUFBZSxDQUFDO0dBQ2xCLFNBQVMsQ0F3QnJCO0FBeEJZLDhCQUFTIn0=